import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ModuleType } from '../manageModule/types/moduleType';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { useIsExtraModule } from 'src/modules/contentList/hooks/useIsExtraModule';
import { ModuleRadio } from './moduleRadio';
export function SelectModuleType() {
    const { t } = useTranslation();
    const { setValue, watch } = useFormContext();
    const { product } = useHostContext();
    const isExtraModule = useIsExtraModule();
    const setModule = useCallback((type) => {
        setValue(ModuleType.Extra, type !== ModuleType.Main, {
            shouldValidate: true
        });
        setValue(ModuleType.PaidModule, type === 'paidModule', {
            shouldValidate: true
        });
    }, [setValue]);
    useEffect(function setExtraModule() {
        if (isExtraModule) {
            setModule(ModuleType.Extra);
        }
    }, [isExtraModule, setModule]);
    const [extra, paidModule] = watch([ModuleType.Extra, ModuleType.PaidModule]);
    return (_jsxs("div", { className: "flex flex-col items-center px-5 pt-6 sm:pt-11", children: [_jsx("h1", { className: "mb-5 text-center text-extralarge font-light sm:mb-7 sm:text-5extralarge", children: t('modules.choose_module_type.title') }), _jsxs("div", { className: "mb-5 flex flex-row flex-wrap justify-center gap-4 sm:gap-5", children: [_jsx(ModuleRadio, { onSelect: setModule, moduleType: ModuleType.Main, isSelected: !extra && !paidModule }), _jsx(ModuleRadio, { onSelect: setModule, moduleType: ModuleType.Extra, isSelected: extra && !paidModule }), _jsx(ModuleRadio, { onSelect: setModule, isSelected: extra && paidModule, moduleType: ModuleType.PaidModule, isDisabled: product.isSubscription, ...(product.isSubscription && {
                            tooltip: t('modules.choose_module_type.additional_paid.tooltip')
                        }) })] })] }));
}
